import { Injectable } from '@angular/core';

import { GenericObjectsService } from './generic-objects.service';

export interface RelayRule {
  id?: string;
  tenantId?: string;
  projectId: string;
  channelId: string;
  serviceDeskId?: string;
  credentialId?: string;
  jsmInstanceId?: string;
  conditions: any;
  enabled: boolean;
  includePrivateMessages?: boolean;
  createdAt?: string;
  updatedAt?: string;
  channel?: any;
}

@Injectable({
  providedIn: 'root',
})
export class RelayRulesService extends GenericObjectsService<RelayRule> {
  protected baseUrl = '/relay-rules';

  /**
   * Create or update a relay rule
   * If rule has an id, it will update, otherwise it will create
   */
  async save(rule: Partial<RelayRule>): Promise<RelayRule> {
    if (rule.id) {
      return this.updatePartial(rule.id, rule);
    } else {
      return this.create(rule);
    }
  }
}
